import { useEffect, useState } from 'react';
import { useAppSelector, usePrevious } from '../index';
export function useAuthentication(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const previousStatus = usePrevious(authentication.status);
    const [error, setError] = useState();
    useEffect(() => setError(authentication.error), [authentication.error]);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'error' && previousStatus !== 'error') {
            (_a = props === null || props === void 0 ? void 0 : props.onError) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'loggedIn' && previousStatus === 'submitting') {
            (_b = props === null || props === void 0 ? void 0 : props.onLogin) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        error,
        status: authentication.status
    };
}
